import { useState, useEffect, useCallback } from "react";
import { UserIcon } from "@heroicons/react/solid";

import Percentile from "./Percentile";

function SubScale(props) {
    const { userName, name, score, description } = props;

    const [position, setPosition] = useState(0);
    const [colour, setColour] = useState("text-blue-gray");

    useEffect(() => {
        setTimeout(() => {
            setPosition(score);
        }, 100);
    }, [score]);

    const handleSetColour = useCallback(async () => {
        setTimeout(() => {
            setColour(score <= 33 ? "green" : score >= 34 && score < 68 ? "amber" : "red");
        }, 100);
    }, [score]);

    useEffect(() => {
        handleSetColour();
    }, [handleSetColour, score]);

    return (
        <div>
            <h2
                className={
                    "cursor-help transition transition-color duration-4000 ease-in-out font-medium text-lg text-" +
                    (colour + "-600")
                }
            >
                {name}
            </h2>
            <div className="flex flex-col-reverse lg:flex-row gap-4 mt-3">
                <div className={"w-full"}>
                    <div
                        className={
                            "w-full p-4 rounded-lg bg-gradient-to-r " +
                            (colour === "red"
                                ? "from-transparent to-red-50"
                                : colour === "green"
                                ? "from-green-50 to-transparent"
                                : "from-transparent via-amber-50 to-transparent")
                        }
                    >
                        <div>
                            <div className="relative w-full bg-slate-200 rounded-lg h-6 mt-2 overflow-hidden">
                                <div
                                    className={
                                        "rounded-lg h-6 border-2 border-white overflow-hidden absolute w-full " +
                                        (colour === "red" ? "bg-red-500" : "bg-red-100")
                                    }
                                    style={{ width: "100%" }}
                                />
                                <div
                                    className={
                                        "rounded-l-lg h-6 border-2 border-white overflow-hidden absolute " +
                                        (colour === "amber" ? "bg-amber-500" : "bg-amber-100")
                                    }
                                    style={{ width: "68%" }}
                                />
                                <div
                                    className={
                                        "rounded-l-lg h-6 border-2 border-white overflow-hidden absolute w-full bg-slate-100 " +
                                        (colour === "green" ? "bg-green-500" : "bg-green-100")
                                    }
                                    style={{ width: "33%" }}
                                />
                            </div>

                            <div
                                className={
                                    "relative transition transition-width duration-4000 w-" + position + "-percentage"
                                }
                            >
                                <div className={"absolute -top-9 -right-0"}>
                                    <div
                                        className={
                                            "flex flex-row gap-1 justify-center items-center text-amber-700 bg-amber-200 " +
                                            (position === 0 ? "opacity-0 " : "opacity-1 ") +
                                            "w-max p-1 rounded-full rounded-br-none transition transition-opacity duration-4000 z-0"
                                        }
                                    >
                                        <UserIcon className="block h-3.5 w-3.5" />
                                        <span className={"text-xs"}>{userName}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {description && <p className={"text-blue-gray-500 mt-2"}>{description}</p>}
                    </div>
                </div>
                <div className={"flex-grow flex items-center justify-center"}>
                    <Percentile size={"large"} percentile={score} colour={colour} />
                </div>
            </div>
        </div>
    );
}

export default SubScale;
